// export const baseURL = 'http://localhost:8080';
export const baseURL = 'https://mern-stact-backend.onrender.com';
